import(/* webpackMode: "eager" */ "/home/user/studio/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/user/studio/src/components/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/user/studio/src/components/ui/toaster.tsx");
